// frontend/src/components/Chat/matrixClient.js
// Создание и управление подключением к Matrix

import { createClient } from "matrix-js-sdk";

import {
  getMatrixBaseUrl,
} from "./matrix";

let matrixClient = null;

export function createMatrixClient(
  accessToken,
  userId
) {
  if (!accessToken || !userId) {
    throw new Error(
      "Matrix accessToken и userId обязательны"
    );
  }

  if (matrixClient) {
    try {
      matrixClient.stopClient();
    } catch (e) {
      console.error(
        "[MATRIX] Ошибка остановки клиента:",
        e
      );
    }

    matrixClient = null;
  }

  matrixClient = createClient({
    baseUrl: getMatrixBaseUrl(),
    accessToken,
    userId,
  });

  return matrixClient;
}

export function startMatrixClient(
  client
) {
  if (!client) {
    throw new Error(
      "Matrix client не создан"
    );
  }

  return new Promise(
    (resolve, reject) => {
      let finished = false;

      function cleanup() {
        client.removeListener(
          "sync",
          handleSync
        );

        client.removeListener(
          "Session.logged_out",
          handleLoggedOut
        );
      }

      function handleSync(
        state,
        prevState,
        data
      ) {
        console.log(
          "[MATRIX] Sync:",
          state
        );

        if (
          state === "PREPARED" ||
          state === "SYNCING"
        ) {
          if (finished) {
            return;
          }

          finished = true;

          cleanup();

          resolve(client);
        }
      }

      function handleLoggedOut() {
        if (finished) {
          return;
        }

        finished = true;

        cleanup();

        reject(
          new Error(
            "Matrix сессия завершена"
          )
        );
      }

      client.on(
        "sync",
        handleSync
      );

      client.on(
        "Session.logged_out",
        handleLoggedOut
      );

      try {
        client.startClient({
          initialSyncLimit: 20,
        });
      } catch (err) {
        cleanup();
        reject(err);
      }
    }
  );
}

export function getMatrixClient() {
  return matrixClient;
}

export function destroyMatrixClient() {
  if (!matrixClient) {
    return;
  }

  try {
    matrixClient.stopClient();
  } catch (e) {
    console.error(
      "[MATRIX] Ошибка остановки клиента:",
      e
    );
  }

  matrixClient = null;
}